import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "destacados",
  class: "container-fluid custom-destacado"
}
const _hoisted_2 = { class: "col-md-10" }
const _hoisted_3 = { class: "row px-md-3 align-items-center" }
const _hoisted_4 = { class: "col-12 col-md-5 text-center text-md-start mb-4 mb-md-0" }
const _hoisted_5 = { class: "col-md-7" }
const _hoisted_6 = { class: "col-md-10" }
const _hoisted_7 = { class: "row px-md-3 align-items-center" }
const _hoisted_8 = { class: "col-12 col-md-5 text-center text-md-start mb-4 mb-md-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold h2 text-uppercase" }, "DESTACADO DEL MES", -1)
const _hoisted_10 = { class: "fw-bold h3 text-uppercase" }
const _hoisted_11 = { class: "fw-bold mb-5 small text-uppercase" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "VER MAS", -1)
const _hoisted_14 = { class: "col-md-7" }

import { ref, onMounted } from 'vue'
import BaseImg from './BaseImg.vue'
import useSitio from '@/composables/useSitio'
import { Skeletor } from 'vue-skeletor'
import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheDestacadoMes',
  props: {
    total: null
  },
  setup(__props: any) {

const props = __props as {
  total: number
};



const isLoading = ref(true)
const { getDestacados } = useSitio()

const destacados = ref<
  {
    actividadId: number
    nombre: string
    bajada: string
    imagen: string
    descripcion: string
  }[]
>([])

// Simular carga de datos
onMounted(async () => {
  isLoading.value = true
  const data = await getDestacados()
  destacados.value = data
  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.total, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "row justify-content-center py-5"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "80%",
                    height: "30px",
                    class: "mb-4 rounded"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "60%",
                    height: "20px",
                    class: "mb-5 small rounded"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "text",
                    width: "100%",
                    height: "60px",
                    class: "mb-4 rounded"
                  }),
                  _createVNode(_unref(Skeletor), {
                    type: "button",
                    width: "150px",
                    height: "40px",
                    class: "rounded"
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Skeletor), {
                    type: "rect",
                    width: "100%",
                    height: "420px",
                    class: "rounded placeholder"
                  })
                ])
              ])
            ])
          ]))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(destacados.value, (destacado) => {
          return (_openBlock(), _createElementBlock("div", {
            key: destacado.actividadId,
            class: "row justify-content-center py-5"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("h3", _hoisted_10, _toDisplayString(destacado.nombre), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(destacado.bajada), 1),
                  _createElementVNode("div", {
                    class: "truncate-multiline",
                    innerHTML: destacado.descripcion
                  }, null, 8, _hoisted_12),
                  _createVNode(_unref(RouterLink), {
                    to: {
                  name: 'Actividad',
                  params: { actividadId: destacado.actividadId }
                },
                    class: "btn btn-primary px-4 py-2 mt-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(BaseImg, {
                    "activididad-id": destacado.actividadId,
                    src: destacado.imagen,
                    alt: "Destacado del mes"
                  }, null, 8, ["activididad-id", "src"])
                ])
              ])
            ])
          ]))
        }), 128))
  ]))
}
}

})